import { get, set } from 'lodash'

import store from 'store/dist/store.everything'

class DataStore {
  constructor() {
    /* istanbul ignore next */
    this.storage = {
      clear: Function.prototype,
      getItem: () => undefined,
      removeItem: () => undefined,
      setItem: Function.prototype,
    }
  }

  clear() {
    this.storage.clear()
  }

  clearAll() {
    this.clear()
  }

  get(key) {
    const value = this.storage?.getItem(key)
    return value ? JSON.parse(value) : undefined
  }

  has(key) {
    return this.get(key) !== undefined
  }

  remove(key) {
    this.storage.removeItem(key)
  }

  set(key, value) {
    this.storage?.setItem?.(key, JSON.stringify(value))
  }
}

export class SessionStorage extends DataStore {
  constructor() {
    super()
    /* istanbul ignore next */
    if (window.sessionStorage) {
      this.storage = window.sessionStorage
    }
  }
}

export class LocalStorage extends DataStore {
  constructor() {
    super()
    /* istanbul ignore next */
    if (window.localStorage) {
      this.storage = window.localStorage
    }
  }
}

export class Storage {
  constructor(localStore = store) {
    this.localStore = localStore
    try {
      this.localStore.set('__test_store__', [{ id: '10', keys: 'dev' }])
      this.localStore.remove('__test_store__')
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
      // Store fallback for IE
      this.localStore = new LocalStorage()
    }
    this.sessionStore = new SessionStorage()
  }

  clear() {
    this.localStore.clearAll()
    this.sessionStore.clear()
  }

  flash(key, value) {
    this.sessionStore.set(key, value)
  }

  get(key) {
    return this.getFlashed(key) || this.getSaved(key)
  }

  getFlashed(key) {
    return this.sessionStore.get(key)
  }

  getSaved(key) {
    const path = key.split('.')
    const scope = path.shift()
    if (!this.localStore.has(scope)) {
      return undefined
    }
    return get(this.localStore.get(scope, {}), path)
  }

  has(key) {
    return !!(this.localStore.has(key) || this.sessionStore.has(key))
  }

  remove(key) {
    this.localStore.remove(key)
    this.sessionStore.remove(key)
  }

  save(key, value) {
    const path = key.split('.')
    const scope = path.shift()
    if (!this.localStore.has(scope)) {
      this.localStore.set(scope, {})
    }
    this.localStore.set(scope, set(this.localStore.get(scope, {}), path, value))
  }

  set(key, value, save) {
    if (save) {
      this.save(key, value)
    } else {
      this.flash(key, value)
    }
  }
}

const storage = new Storage()
export default storage
